import { Box, Typography } from "@mui/material";
import {
	getZoneColor,
	GRAY_COLOR,
	type SixZoneThresholds,
} from "./incentiveColors";

type Props = {
	value: number | null;
	thresholds: SixZoneThresholds;
	/** When true, a zero value renders gray (no data yet) instead of red (missed target). */
	isFuture?: boolean;
};

export const IncPercentPill = ({ value, thresholds, isFuture }: Props) => {
	const { bg, text } =
		isFuture && value === 0 ? GRAY_COLOR : getZoneColor(value, thresholds);

	return (
		<Box
			role="status"
			aria-label={value != null ? `${value.toFixed(1)}% incentive` : "No data"}
			sx={{
				display: "inline-flex",
				alignItems: "center",
				justifyContent: "center",
				backgroundColor: bg,
				color: text,
				borderRadius: "12px",
				px: 1,
				py: 0.25,
				minWidth: 52,
			}}
		>
			<Typography
				sx={{
					fontSize: "0.75rem",
					fontWeight: 600,
					lineHeight: 1.2,
				}}
			>
				{value != null ? `${value.toFixed(1)}%` : "—"}
			</Typography>
		</Box>
	);
};
